// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const sessionInstructionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessionInstructions: builder.query({
      query: (queryParams = {}) => {
        const qs = new URLSearchParams(queryParams).toString();
        return `session_instruction/?${qs}`;
      },
      providesTags: ['SessionInstruction'],
    }),
    createSessionInstruction: builder.mutation({
      query: body => ({
        url: 'session_instruction/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['SessionInstruction'],
    }),
    updateSessionInstruction: builder.mutation({
      query: ({ id, body }) => ({
        url: `session_instruction/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['SessionInstruction'],
    }),
    removeSessionInstruction: builder.mutation({
      query: ({ id }) => ({
        url: `session_instruction/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SessionInstruction'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSessionInstructionsQuery,
  useCreateSessionInstructionMutation,
  useUpdateSessionInstructionMutation,
  useRemoveSessionInstructionMutation
} = sessionInstructionApi;
